import {TYPE_VIRTUAL} from '../constants';

export const createDataTree = data => {

  const tree = {
    name: 'Online Groups',
    children: [],
  };

  let onlinePlatform = {};
  const sortedData = data
    .filter(item => item.primaryType === TYPE_VIRTUAL)
    .sort((a, b) => a.onlinePlatform.localeCompare(b.onlinePlatform));
  sortedData.forEach((item, index) => {
    // Switch parent regarding the platform's type.
    if (onlinePlatform.name && onlinePlatform.name !== item.onlinePlatform) {
      tree.children.push(onlinePlatform);
      onlinePlatform = {};
    }
    // Add required props to the object.
    if (!onlinePlatform.children) {
      onlinePlatform = {name: item.onlinePlatform, children: []};
    }
    // Add group to the tree.
    onlinePlatform.children.push({
      name: item.groupName,
      link: item.link,
      size: item.numUsers,
    });
    // Process last group.
    if (sortedData[index + 1] === undefined) {
      tree.children.push(onlinePlatform);
    }
  });

  return tree;
};

export const setTreeValue = (node, prop = 'size') => {
  if (node.children) {
    node.children = node.children.map(item => setTreeValue(item, prop));
  }
  else {
    node.value = node[prop];
  }
  return node;
};
